import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-delete-popup b-blue-background b-blue-background__opacity b-blue-background--fixed" }
const _hoisted_2 = { class: "h-flex-dir-column h-flex-center" }
const _hoisted_3 = { class: "h-font-22 h-mv-0 h-text-center" }
const _hoisted_4 = { class: "b-delete-popup__aside" }
const _hoisted_5 = {
  class: "h-flex h-flex-center h-flex-dir-column",
  style: {"height":"20%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      iconColor: "#BEC7D4",
      "max-width": "400px",
      width: "auto",
      title: "",
      popupBackground: "#F8F9FA",
      popupRadius: "20px",
      heightValue: "100%",
      allowBackgroundScrolling: "",
      showClosePopup: "",
      centered: "",
      isFixed: "",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("close")))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.headerText)), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.bodyText)), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FwButton, {
            class: "h-mt-20 qa-remove-this-alone",
            borderRadiusType: "small-border",
            disabled: _ctx.isRequestSending,
            onClick: _ctx.deSyncCalendar
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.btnText)), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("div", {
            class: "b-delete-popup__delete h-mt-20",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
          }, _toDisplayString(_ctx.$t('BUTTON.CANCEL')), 1)
        ])
      ]),
      _: 1
    })
  ]))
}